export default () => {
  const calculators = document.querySelectorAll('.js-calculator')

  const calculateResult = (inputs, currency) => {
    const {
      investmentInput,
      costInput,
      fullCostInput,
      dropdownInput,
      savingsResult,
      monthsResult,
      calculator
    } = inputs

    if (!investmentInput.value) {
      return
    }

    const investment = investmentInput
      ? investmentInput.value > 0
        ? `?${investmentInput.dataset.cart}=${investmentInput.value}`
        : ''
      : ''

    const cost = costInput
      ? costInput.value > 0
        ? `&lost=${costInput.value}`
        : ''
      : ''

    const fullCost = fullCostInput
      ? fullCostInput.value
        ? `&full_lost=${fullCostInput.value}&full_cost=${dropdownInput.value}`
        : ''
      : ''

    window
      .fetch(
        `/wp-json/rocateq/v1/calculate_price/${investment}${cost}${fullCost}${currency}`,
        {
          credentials: 'same-origin'
        }
      )
      .then(response => {
        if (!response.ok) {
          // Fetch doesn't reject on HTTP error status
          throw Error(`Request rejected with status ${response.status}`)
        }
        return response.json()
      })
      .then(response => {
        if (response.error) {
          console.log(response.error)
        }

        // Set results
        if (response.saving && response.months) {
          savingsResult.value =
            savingsResult.dataset.currency +
            ' ' +
            new Intl.NumberFormat().format(response.saving)
          console.log(monthsResult.dataset.translation)
          monthsResult.value =
            Intl.NumberFormat().format(response.months.toFixed(2)) +
            ' ' +
            monthsResult.dataset.translation

          calculator.classList.add('active')

          // calculator send mail popup
          const popup = calculator.querySelector('.js-popup-cta')
          if (popup) {
            console.log(response)
            console.log(fullCostInput.value)
            console.log(dropdownInput)
            console.log(dropdownInput.value)
            popup.classList.add('active')
            calculator.querySelector('input[name="carts"]').value =
              investmentInput.value
            calculator.querySelector('input[name="carts_price"]').value =
              savingsResult.dataset.currency + ' ' + response.amount
            calculator.querySelector(
              'input[name="carts_lost"]'
            ).value = costInput ? costInput.value : fullCostInput.value
            if (calculator.querySelector('input[name="carts_value"]'))
              calculator.querySelector('input[name="carts_value"]').value =
                dropdownInput.value
            calculator.querySelector('input[name="carts_lost_price"]').value =
              savingsResult.dataset.currency +
              ' ' +
              (response.lost ? response.lost : response.full_lost)
            calculator.querySelector(
              'input[name="full_return_on_investment"]'
            ).value = response.months
            calculator.querySelector('input[name="lustrum_returns"]').value =
              savingsResult.dataset.currency + ' ' + response.saving
          }

          console.log(response)
        }
      })
  }

  const calculate = (e, input, result, error, type, inputs, currency) => {
    const fullCart = inputs.dropdownInput
      ? `&full_cost=${inputs.dropdownInput.value}`
      : ''

    window
      .fetch(
        `/wp-json/rocateq/v1/calculate_price/?${
          input.dataset.cart ? input.dataset.cart : type
        }=${input.value}${fullCart}${currency}`,
        {
          credentials: 'same-origin'
        }
      )
      .then(response => {
        if (!response.ok) {
          // Fetch doesn't reject on HTTP error status
          throw Error(`Request rejected with status ${response.status}`)
        }
        return response.json()
      })
      .then(response => {
        if (response.error) {
          error.classList.add('active')
        }
        if (response[`${type}`] > 0) {
          error.classList.remove('active')
          result.value =
            input.dataset.currency +
            ' ' +
            new Intl.NumberFormat().format(response[`${type}`])

          // Calculate results if value is set
          calculateResult(inputs, currency)
        }
      })
  }

  const setEvents = (
    input,
    result,
    error,
    type,
    inputs,
    dropdown,
    currency
  ) => {
    let timer = 0
    input.addEventListener('blur', e => {
      calculate(e, input, result, error, type, inputs, currency)
    })

    // Stop typing
    input.addEventListener('input', e => {
      clearTimeout(timer)

      timer = setTimeout(() => {
        calculate(e, input, result, error, type, inputs, currency)
      }, 1000)
    })

    if (dropdown) {
      dropdown.addEventListener('change', e => {
        calculate(e, input, result, error, type, inputs, currency)
      })
    }
  }

  ;[...calculators].forEach(calculator => {
    const form = calculator.querySelector('.js-calculator-form')
    const investmentInput = form.querySelector('.js-investment-input')
    const investmentResult = form.querySelector('.js-investment-result')
    const investmentError = form.querySelector('.js-investment-error')
    const costInput = form.querySelector('.js-empty-cost-input')
    const costResult = form.querySelector('.js-empty-cost-result')
    const costError = form.querySelector('.js-empty-cost-error')
    const fullCostInput = form.querySelector('.js-full-cost-input')
    const fullCostResult = form.querySelector('.js-full-cost-result')
    const fullCostError = form.querySelector('.js-full-cost-error')
    const dropdown = form.querySelector('.js-calculator-dropdown')
    const savingsResult = form.querySelector('.js-savings-result')
    const monthsResult = form.querySelector('.js-months-result')
    const currency = form.dataset.currency
      ? `&currency=${form.dataset.currency}`
      : '&currency=€'

    if (!investmentInput) {
      return
    }

    if (!costInput && !fullCostInput) {
      return
    }

    const inputs = {
      investmentInput: investmentInput,
      costInput: costInput,
      fullCostInput: fullCostInput,
      dropdownInput: dropdown,
      savingsResult: savingsResult,
      monthsResult: monthsResult,
      calculator: calculator
    }

    setEvents(
      investmentInput,
      investmentResult,
      investmentError,
      'amount',
      inputs,
      null,
      currency
    )

    if (costInput) {
      setEvents(
        costInput,
        costResult,
        costError,
        'lost',
        inputs,
        null,
        currency
      )
    }

    if (fullCostInput) {
      setEvents(
        fullCostInput,
        fullCostResult,
        fullCostError,
        'full_lost',
        inputs,
        dropdown,
        currency
      )
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Calculator.js